module.exports = __webpack_public_path__ + "static/media/IMG_0399.cff1ca25.JPG";